import React from 'react';

// Types
import { AutoGridProps } from '../../types/composition/autoGrid';

export const AutoGrid = ({ children, placement }: AutoGridProps) => (
  <div
    className="auto-grid"
    style={{ ['--c6-auto-grid-placement' as string]: placement }}
  >
    {children}
  </div>
);
